import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Emit, Mixins } from 'vue-property-decorator';
import Component from 'vue-class-component';

var AllowedCountriesModalComponent = /** @class */ (function (_super) {
    __extends(AllowedCountriesModalComponent, _super);
    function AllowedCountriesModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllowedCountriesModalComponent.prototype.exit = function () {
        return;
    };
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AllowedCountriesModalComponent.prototype, "exit", null);
    AllowedCountriesModalComponent = __decorate([
        Component({
            name: 'allowed-countries-modal',
        })
    ], AllowedCountriesModalComponent);
    return AllowedCountriesModalComponent;
}(Mixins(MagicConfigMixin)));

export default AllowedCountriesModalComponent;
